import { useEffect, useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import { unsubscribeNewsletter } from '@/services/newsletter';

export default function NewsletterUnsubscribe() {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const token = searchParams.get('token') || searchParams.get('Token') || '';
  const [status, setStatus] = useState<'loading' | 'success' | 'error'>('loading');
  const [message, setMessage] = useState('');

  useEffect(() => {
    let alive = true;
    if (!token) {
      setStatus('error');
      setMessage('連結無效或已失效。');
      return;
    }
    unsubscribeNewsletter(token).then((result) => {
      if (!alive) return;
      setStatus(result.ok ? 'success' : 'error');
      setMessage(result.message);
    });
    return () => {
      alive = false;
    };
  }, [token]);

  return (
    <div className="min-h-screen bg-white">
      <Navbar />
      <main className="pt-20 md:pt-24">
        <div className="mx-auto max-w-md px-6 py-16 text-center md:py-24">
          <div className="mx-auto flex h-16 w-16 items-center justify-center rounded-full bg-[#FAF8F5]">
            {status === 'loading' && <i className="ri-loader-4-line animate-spin text-2xl text-[#9A8A7A]" />}
            {status === 'success' && <i className="ri-checkbox-circle-line text-2xl text-[#1B3D2A]" />}
            {status === 'error' && <i className="ri-error-warning-line text-2xl text-[#c3423f]" />}
          </div>
          <h1 className="mt-5 text-xl font-bold text-[#1B3D2A] md:text-2xl">
            {status === 'loading' ? '處理中...' : status === 'success' ? '取消訂閱成功' : '取消訂閱失敗'}
          </h1>
          {message && <p className="mt-3 text-sm leading-relaxed text-[#9A8A7A]">{message}</p>}
          <button
            type="button"
            onClick={() => navigate('/')}
            className="mt-8 inline-flex items-center gap-2 rounded-xl bg-[#1B3D2A] px-6 py-3 text-sm font-medium text-white transition-colors hover:bg-[#143026]"
          >
            <i className="ri-home-4-line" />
            回首頁
          </button>
        </div>
      </main>
      <Footer />
    </div>
  );
}
